import { FeatureGroupEnum } from '@hotjar/webapp/domains/revenue/plan/types';
import type { FeatureGroup } from '@hotjar/webapp/domains/revenue/plan/types';
import type { PlanComparisonReferrer, TrafficRecommendationReferrer } from './types';
import {
  planComparisonFeatureGatesByReferrer,
  TrafficRecommendationFeatureGateByReferrer,
} from './constants';

export const getFeatureGroupsGreaterThanOrEqualTo = (
  featureGroup: FeatureGroup,
): Array<FeatureGroup> => {
  return (Object.keys(FeatureGroupEnum) as Array<FeatureGroup>).filter(
    (featureGroupEnumKey) =>
      FeatureGroupEnum[featureGroupEnumKey] >= FeatureGroupEnum[featureGroup],
  );
};

export const getFeatureGateNameByReferrer = (referrer: string): string | null => {
  return (
    (planComparisonFeatureGatesByReferrer[referrer as PlanComparisonReferrer] ||
      TrafficRecommendationFeatureGateByReferrer[referrer as TrafficRecommendationReferrer]) ??
    null
  );
};
